import { AuditLogData } from "../types/AuditLog";
import { ParamData } from "../types/Param";
import { clientApiUrl } from "./api";

const API_URL = "/Audits";

export const getUserLogData = async (
  param: ParamData
): Promise<AuditLogData[]> => {
  try {
    const res = await clientApiUrl.get<AuditLogData[]>(`${API_URL}/users-log`, {
      params: {
        user: param.user,
        startingFrom: param.startingFrom,
        endingOn: param.endingOn,
      },
    });
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all trackers error: ${
        error.response?.data?.message || error.message
      }`
    );
    return [];
  }
};

export const getEntityLogData = async (
  param: ParamData
): Promise<AuditLogData[]> => {
  try {
    const res = await clientApiUrl.get<AuditLogData[]>(
      `${API_URL}/entities-log`,
      {
        params: {
          entity: param.entity,
          startingFrom: param.startingFrom,
          endingOn: param.endingOn,
        },
      }
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all trackers error: ${
        error.response?.data?.message || error.message
      }`
    );
    return [];
  }
};

export const getUserListData = async (): Promise<string[]> => {
  try {
    const res = await clientApiUrl.get<string[]>(`${API_URL}/users`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all trackers error: ${
        error.response?.data?.message || error.message
      }`
    );
    return [];
  }
};

export const getEntityListData = async (): Promise<string[]> => {
  try {
    const res = await clientApiUrl.get<string[]>(`${API_URL}/entities`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all trackers error: ${
        error.response?.data?.message || error.message
      }`
    );
    return [];
  }
};
